/* Manu AI v11 (19/10/2026) — agent créatif plus puissant
 * - Conversation guidée mais ouverte : Manu répond aux questions boutique (prix, délais, Rush, tailles…) avec les
 *   infos du site (« facts » envoyés au chat), puis relance la création. Réponses en un clic (suggestions de Manu).
 * - Orientation : designs signature, templates photo IA (caricature…) ou import, quand c'est plus adapté.
 * - Image du visiteur (trombone) : Manu la regarde (vision) puis « L'imprimer telle quelle » ou « M'en inspirer ».
 *   Inspiration = l'image part avec le premier logo dessiné (action logo, champ inspire), jamais copiée.
 * - Après le dessin, un message libre passe d'abord par Manu (stage result) : une question ne relance plus un dessin payant.
 * - Mockups : photos Shopify des variantes (vêtement vierge devant + dos) avec le logo posé dans les zones du bloc Support.
 * - Prix + délai (« prêt à expédier le … · Rush … ») dans l'aperçu, le choix du vêtement et le récapitulatif.
 * - Ouverture depuis un lien : /?manu=1 (menu mobile, accès direct) ou /?manu=remix (bouton « Remixer avec Manu » des
 *   fiches perso : rendu Teeinblue capturé par snippets/rx-manu-remix.liquid, rangé en sessionStorage rxManuSeed).
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par ai-studio-v9.js et -v10.js, chargés avant. */
(function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function colorKey(n) { return String(n || '').trim().toLowerCase(); }
  function loadImg(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  // Réponse de Manu : texte échappé, **gras** autorisé (le modèle en met parfois)
  function rich(x) { return esc(x).replace(/\*\*([^*]{1,80})\*\*/g, '<strong>$1</strong>').replace(/\*/g, ''); }
  function readUrl(file) { return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(file); }); }
  // Image réduite (côté max) : PNG si elle a de la transparence, sinon JPEG
  function shrink(src, max) {
    return loadImg(src).then(function (img) {
      var w = img.naturalWidth || 800, h = img.naturalHeight || 800, k = Math.min(1, max / Math.max(w, h));
      var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, c.width, c.height);
      var d = x.getImageData(0, 0, c.width, c.height).data, alpha = false;
      for (var i = 3; i < d.length; i += 16) if (d[i] < 250) { alpha = true; break; }
      return { url: alpha ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.85), w: c.width, h: c.height, alpha: alpha };
    });
  }

  var SIZES = { front: [28, 12], back: [28, 32] };
  var FACES = ['front', 'back'];
  // Même calcul que placeRect() de ai-studio.js (rectangle du logo dans la zone, en cm)
  function placeRect(face, side, pos) {
    var S = SIZES[side], W = S[0], H = S[1], r = face && face.w && face.h ? face.w / face.h : (side === 'back' ? 0.94 : 2.37);
    var iw = W, ih = W / r;
    if (ih > H) { ih = H; iw = H * r; }
    var k = pos ? clamp(pos.k, 0.2, 1) : 1, w = iw * k, h = ih * k;
    var cx = clamp((pos ? pos.x : 0.5) * W, w / 2, W - w / 2), cy = clamp((pos ? pos.y : 0.5) * H, h / 2, H - h / 2);
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, W: W, H: H };
  }

  var IC = {
    clip: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.4 11.6l-8.5 8.5a5.5 5.5 0 0 1-7.8-7.8l8.5-8.5a3.7 3.7 0 0 1 5.2 5.2l-8.5 8.5a1.8 1.8 0 0 1-2.6-2.6l7.8-7.8"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    redo: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/></svg>',
    spark: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5M5 20h14"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  // Textes v11 (5 langues). Les autres textes du panneau restent dans ai-studio-i18n*.js
  var T = {
    fr: {
      e_redo: 'Refaire', e_create: 'Créer avec Manu', e_upload: 'Importer', e_remove: 'Retirer', e_add: 'Ajouter', e_product: 'Choisis ton support', e_color: 'Couleur', e_hint: 'Glisse un logo pour le placer, tire son coin pour l’agrandir.', e_select: 'Logo {side} : glisse pour le déplacer, flèches du clavier, + et − pour la taille', restart_t: 'Nouvelle création',
      attach: 'Joindre une image', img_msg: 'Voilà mon image.', img_bad: 'Je lis les images PNG, JPG, WebP ou SVG, jusqu’à 15 Mo.',
      img_print: 'L’imprimer telle quelle', img_inspire: 'M’en inspirer', img_idea: 'Un design inspiré de mon image',
      welcome: 'Salut, moi c’est Manu ! Décris ton idée en une phrase : je te propose le devant et le dos, puis je dessine.',
      w_noidea: 'Je n’ai pas d’idée', w_logo: 'J’ai déjà mon logo', w_designs: 'Voir les designs signature', w_photo: 'Caricature avec ma photo',
      remix_msg: 'Je veux remixer « {t} » pour en faire un design unique.', remix_mine: 'Je veux remixer ma personnalisation pour en faire un design unique.', remix_texts: 'Mes textes : {x}.', remix_lost: 'Je n’ai pas retrouvé ta personnalisation : décris-moi ce que tu veux garder et changer.',
      route_photo: 'Avec ta photo, c’est dans ces modèles :', route_designs: 'Des designs signature qui collent :', route_upload: 'Importer mon fichier',
      from: 'à partir de {p}', ready_on: 'Prêt à expédier le {d}', rush_on: 'Rush : le {d}', rush_plus: '+{p}',
      chat_error: 'Petit souci de connexion. Réessaie ton message.', no_idea_msg: 'Je n’ai pas d’idée, propose-moi des pistes.'
    },
    en: {
      e_redo: 'Redo', e_create: 'Create with Manu', e_upload: 'Upload', e_remove: 'Remove', e_add: 'Add', e_product: 'Choose your garment', e_color: 'Colour', e_hint: 'Drag a logo to place it, pull its corner to resize it.', e_select: '{side} logo: drag to move, arrow keys, + and − to resize', restart_t: 'New creation',
      attach: 'Attach an image', img_msg: 'Here is my image.', img_bad: 'I can read PNG, JPG, WebP or SVG images, up to 15 MB.',
      img_print: 'Print it as is', img_inspire: 'Use it as inspiration', img_idea: 'A design inspired by my image',
      welcome: 'Hi, I’m Manu! Describe your idea in one sentence: I’ll suggest the front and back, then draw it.',
      w_noidea: 'I have no idea yet', w_logo: 'I already have my logo', w_designs: 'See signature designs', w_photo: 'Caricature from my photo',
      remix_msg: 'I want to remix “{t}” into a unique design.', remix_mine: 'I want to remix my customisation into a unique design.', remix_texts: 'My texts: {x}.', remix_lost: 'I couldn’t find your customisation: tell me what to keep and what to change.',
      route_photo: 'With your photo, it happens in these designs:', route_designs: 'Signature designs that fit:', route_upload: 'Upload my file',
      from: 'from {p}', ready_on: 'Ready to ship on {d}', rush_on: 'Rush: {d}', rush_plus: '+{p}',
      chat_error: 'Small connection issue. Please send your message again.', no_idea_msg: 'I have no idea yet, give me some leads.'
    },
    es: {
      e_redo: 'Rehacer', e_create: 'Crear con Manu', e_upload: 'Subir', e_remove: 'Quitar', e_add: 'Añadir', e_product: 'Elige tu prenda', e_color: 'Color', e_hint: 'Arrastra un logo para colocarlo, tira de su esquina para agrandarlo.', e_select: 'Logo {side}: arrastra para moverlo, flechas del teclado, + y − para el tamaño', restart_t: 'Nueva creación',
      attach: 'Adjuntar una imagen', img_msg: 'Aquí está mi imagen.', img_bad: 'Leo imágenes PNG, JPG, WebP o SVG, hasta 15 MB.',
      img_print: 'Imprimirla tal cual', img_inspire: 'Inspirarme en ella', img_idea: 'Un diseño inspirado en mi imagen',
      welcome: '¡Hola, soy Manu! Describe tu idea en una frase: te propongo delante y espalda, y luego lo dibujo.',
      w_noidea: 'No tengo idea', w_logo: 'Ya tengo mi logo', w_designs: 'Ver los diseños firma', w_photo: 'Caricatura con mi foto',
      remix_msg: 'Quiero remezclar «{t}» para hacer un diseño único.', remix_mine: 'Quiero remezclar mi personalización para hacer un diseño único.', remix_texts: 'Mis textos: {x}.', remix_lost: 'No encontré tu personalización: dime qué quieres conservar y cambiar.',
      route_photo: 'Con tu foto, se hace en estos diseños:', route_designs: 'Diseños firma que encajan:', route_upload: 'Subir mi archivo',
      from: 'desde {p}', ready_on: 'Listo para enviar el {d}', rush_on: 'Rush: el {d}', rush_plus: '+{p}',
      chat_error: 'Pequeño problema de conexión. Vuelve a enviar tu mensaje.', no_idea_msg: 'No tengo idea, propónme pistas.'
    },
    de: {
      e_redo: 'Neu', e_create: 'Mit Manu gestalten', e_upload: 'Hochladen', e_remove: 'Entfernen', e_add: 'Hinzufügen', e_product: 'Wähle dein Shirt', e_color: 'Farbe', e_hint: 'Zieh ein Logo, um es zu platzieren, zieh an der Ecke, um es zu vergrößern.', e_select: 'Logo {side}: ziehen zum Verschieben, Pfeiltasten, + und − für die Größe', restart_t: 'Neue Kreation',
      attach: 'Bild anhängen', img_msg: 'Hier ist mein Bild.', img_bad: 'Ich lese PNG-, JPG-, WebP- oder SVG-Bilder bis 15 MB.',
      img_print: 'So drucken', img_inspire: 'Als Inspiration nutzen', img_idea: 'Ein Design inspiriert von meinem Bild',
      welcome: 'Hi, ich bin Manu! Beschreib deine Idee in einem Satz: Ich schlage Vorder- und Rückseite vor und zeichne dann.',
      w_noidea: 'Ich habe keine Idee', w_logo: 'Ich habe schon mein Logo', w_designs: 'Signature-Designs ansehen', w_photo: 'Karikatur mit meinem Foto',
      remix_msg: 'Ich möchte „{t}“ zu einem einzigartigen Design remixen.', remix_mine: 'Ich möchte meine Personalisierung zu einem einzigartigen Design remixen.', remix_texts: 'Meine Texte: {x}.', remix_lost: 'Ich habe deine Personalisierung nicht gefunden: Sag mir, was bleiben und was sich ändern soll.',
      route_photo: 'Mit deinem Foto geht das in diesen Designs:', route_designs: 'Passende Signature-Designs:', route_upload: 'Meine Datei hochladen',
      from: 'ab {p}', ready_on: 'Versandbereit am {d}', rush_on: 'Rush: am {d}', rush_plus: '+{p}',
      chat_error: 'Kleines Verbindungsproblem. Bitte sende deine Nachricht noch einmal.', no_idea_msg: 'Ich habe keine Idee, schlag mir etwas vor.'
    },
    it: {
      e_redo: 'Rifai', e_create: 'Crea con Manu', e_upload: 'Carica', e_remove: 'Togli', e_add: 'Aggiungi', e_product: 'Scegli il tuo capo', e_color: 'Colore', e_hint: 'Trascina un logo per posizionarlo, tira l’angolo per ingrandirlo.', e_select: 'Logo {side}: trascina per spostarlo, frecce, + e − per la dimensione', restart_t: 'Nuova creazione',
      attach: 'Allega un’immagine', img_msg: 'Ecco la mia immagine.', img_bad: 'Leggo immagini PNG, JPG, WebP o SVG, fino a 15 MB.',
      img_print: 'Stamparla così', img_inspire: 'Ispirarmi', img_idea: 'Un design ispirato alla mia immagine',
      welcome: 'Ciao, sono Manu! Descrivi la tua idea in una frase: ti propongo davanti e retro, poi disegno.',
      w_noidea: 'Non ho idee', w_logo: 'Ho già il mio logo', w_designs: 'Vedi i design firma', w_photo: 'Caricatura con la mia foto',
      remix_msg: 'Voglio remixare «{t}» per farne un design unico.', remix_mine: 'Voglio remixare la mia personalizzazione per farne un design unico.', remix_texts: 'I miei testi: {x}.', remix_lost: 'Non ho trovato la tua personalizzazione: dimmi cosa tenere e cosa cambiare.',
      route_photo: 'Con la tua foto, si fa in questi design:', route_designs: 'Design firma adatti:', route_upload: 'Carica il mio file',
      from: 'da {p}', ready_on: 'Pronto per la spedizione il {d}', rush_on: 'Rush: il {d}', rush_plus: '+{p}',
      chat_error: 'Piccolo problema di connessione. Rimanda il messaggio.', no_idea_msg: 'Non ho idee, proponimi delle piste.'
    }
  };
  var BLOCKED = /\b(nike|adidas|puma|reebok|under ?armou?r|asics|hoka|lululemon|gymshark|disney|marvel|pixar|pok[eé]mon|mickey|simpsons?|naruto|one ?piece|dragon ?ball|starbucks|coca|red ?bull|mario|spider-?man|batman|superman|gta)\b/i;
  var NICHE_OF = { running: 'running', trail: 'running', crossfit: 'cf', hyrox: 'cf', fitness: 'cf', other: 'cf' };
  var SPORTS = ['running', 'trail', 'crossfit', 'hyrox', 'fitness', 'other'];

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v11) return;
    inst._v11 = true;
    var t = T[inst.loc] || T.en;
    var bt = inst.t || {};
    var loc = inst.loc;

    /* ---------- Infos boutique : prix des vêtements + délais du moment (api/delai-public) ---------- */
    var dayFmt = function (iso) {
      if (!iso) return '';
      try { return new Date(iso + 'T12:00:00').toLocaleDateString(loc === 'en' ? 'en-GB' : loc, { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { return iso; }
    };
    var euro = function (v) {
      var n = parseFloat(String(v).replace(',', '.')); if (!(n >= 0)) return String(v);
      try { return n.toLocaleString(loc === 'en' ? 'en-GB' : loc, { style: 'currency', currency: 'EUR', minimumFractionDigits: n % 1 ? 2 : 0 }); } catch (e) { return n + ' €'; }
    };
    inst.loadDelay = function () {
      if (this.delayP) return this.delayP;
      var url = this.endpoint ? this.endpoint.replace(/\/api\/studio.*$/, '/api/delai-public') : '';
      var self = this;
      this.delayP = !url ? Promise.resolve(null) : fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          return {
            normal: dayFmt(j.dateNormaleISO), rush: j.rushIndisponible ? '' : dayFmt(j.dateRushISO),
            rush_price: j.rush && j.rush.price ? euro(j.rush.price) : '',
            closed: j.enFermetureAujourdhui ? (j.fermeture && (j.fermeture.label || j.fermeture.titre) || 'fermé aujourd’hui') : ''
          };
        })
        .catch(function () { self.delayP = null; return null; });
      return this.delayP;
    };
    inst.priceOf = function (sp) { return sp && sp.price ? sp.price : ''; };
    inst.fromPrice = function (niche) {
      var list = this.supportsFor(niche || this.s.niche), min = null;
      list.forEach(function (sp) { if (sp.amount > 0 && (min === null || sp.amount < min.amount)) min = sp; });
      return min ? min.price : '';
    };
    inst.loadFacts = function () {
      var self = this;
      return this.loadDelay().then(function (d) {
        var seen = {}, prices = [];
        self.supports.forEach(function (sp) { var n = String(sp.t || '').split(' (')[0]; if (seen[n]) return; seen[n] = 1; prices.push({ t: n, price: sp.price }); });
        var cols = self.palette().map(function (c) { return c.n; }).slice(0, 12).join(', ');
        return { prices: prices, colors: cols, delay: d || {} };
      });
    };
    // Ligne prix + délai (aperçu, choix du vêtement, récapitulatif)
    inst.delayLine = function (price) {
      var d = this.delayInfo;
      var bits = [];
      if (price) bits.push('<span class="ais-delay__price">' + esc(price) + '</span>');
      if (d && d.normal) bits.push('<span>' + IC.clock + esc(fmt(t.ready_on, { d: d.normal })) + '</span>');
      if (d && d.rush) bits.push('<span>' + IC.bolt + esc(fmt(t.rush_on, { d: d.rush })) + (d.rush_price ? ' <em>' + esc(fmt(t.rush_plus, { p: d.rush_price })) + '</em>' : '') + '</span>');
      return bits.length ? '<p class="ais-delay">' + bits.join('') + '</p>' : '';
    };
    inst.loadDelay().then(function (d) { inst.delayInfo = d; });

    /* ---------- Mockups : photo Shopify de la variante (devant + dos) + logos posés dans les zones ---------- */
    var baseMock = inst.mock;
    /* Zones d'impression (back-office, onglet « Zones », metafield rxwear_print.zones, 19/10/2026) :
     * sp.zp = { avant: { w, h (mm), photo: [x, y, l, h] (% de la photo, haut-gauche) }, arriere: {…} }.
     * Converti en pz = [centre, haut, largeur, hauteur] ; sans entrée : curseurs du bloc Support (repli). */
    (inst.supports || []).forEach(function (sp) {
      var a = sp && sp.zp && sp.zp.avant, b = sp && sp.zp && sp.zp.arriere;
      var cv = function (f) { var r = f && f.photo; return r && r.length === 4 ? [r[0] + r[2] / 2, r[1], r[2], r[3]] : null; };
      if (cv(a) || cv(b)) sp.pz = [cv(a) || (sp.pz && sp.pz[0]) || null, cv(b) || (sp.pz && sp.pz[1]) || null];
    });
    // Cadre = zone d'impression technique du produit (rxwear_print.zones) ; le logo y reprend la position et les proportions du mockup (logoBox)
    function frameOf(z, side) {
      var S = SIZES[side];
      if (z.length >= 4 && z[3] > 0) return { x: z[0] - z[2] / 2, y: z[1], w: z[2], h: z[3] };
      return { x: z[0] - z[2] / 2, y: z[1], w: z[2], h: z[2] * S[1] / S[0] };
    }
    inst.photoOf = function (sp, color) {
      var ph = sp && sp.photos; if (!ph) return null;
      var k = colorKey(color);
      if (ph[k]) return ph[k];
      var c = this.colorOf(color), dark = true;
      try { var h = String(c.h || '#000').replace('#', ''); dark = (0.299 * parseInt(h.slice(0, 2), 16) + 0.587 * parseInt(h.slice(2, 4), 16) + 0.114 * parseInt(h.slice(4, 6), 16)) / 255 < 0.55; } catch (e) {}
      return dark ? (ph.noir || ph.black || null) : (ph.blanc || ph.white || null);
    };
    // Mobile : un t-shirt à la fois, cadré sur sa zone d'impression ; « Tout le t-shirt » rend la photo entière (inst.v25 = { side, full })
    var MTX = { fr: ['Tout le t-shirt', 'Zoom sur le logo'], en: ['Whole T-shirt', 'Zoom on logo'], es: ['Camiseta entera', 'Zoom al logo'], de: ['Ganzes T-Shirt', 'Logo heranzoomen'], it: ['Maglia intera', 'Zoom sul logo'] };
    function mobCrop(self, sp, both) {
      var s = self.s, mob = !!both && !!window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var have = FACES.filter(function (f, i) { return s.faces[f] && sp.pz[i]; });
      var V = self.v25 = self.v25 || { side: null, full: false };
      var cur = have.indexOf(V.side) > -1 ? V.side : have[0], out = { mob: mob, tr: '', k: 1, sw: '' };
      if (!mob || !cur) return out;
      if (!V.full) {
        var Fc = frameOf(sp.pz[FACES.indexOf(cur)], cur), kz = clamp(62 / Fc.w, 1, 5);
        var X = clamp(Fc.x + Fc.w / 2 - 50 / kz, 0, 100 - 100 / kz), Y = clamp(Fc.y + Fc.h / 2 - 50 / kz, 0, 100 - 100 / kz);
        out.k = kz; out.tr = ' style="--k:' + kz.toFixed(3) + ';transform:scale(' + kz.toFixed(3) + ') translate(' + (-X).toFixed(2) + '%,' + (-Y).toFixed(2) + '%)"';
      }
      var MT = MTX[self.loc] || MTX.en;
      out.sw = '<span class="ais-mock__sw" role="group">' +
        (have.length > 1 ? have.map(function (f) { return '<button type="button" class="ais-mock__swb" data-v25-side="' + f + '" aria-pressed="' + (f === cur) + '">' + esc((bt.sides && bt.sides[f]) || f) + '</button>'; }).join('') : '') +
        '<button type="button" class="ais-mock__swb ais-mock__swb--w" data-v25-full aria-pressed="' + !!V.full + '">' + esc(V.full ? MT[1] : MT[0]) + '</button></span>';
      return out;
    }
    inst.mock = function (sp, color, badge, both) {
      var photo = sp && sp.pz && this.photoOf(sp, color);
      if (!photo) return baseMock.apply(this, arguments);
      var s = this.s, self = this, c = this.colorOf(color);
      var has = !sp.colors || !sp.colors.length || sp.colors.some(function (x) { return colorKey(x.n) === c.k; });
      var data = esc(JSON.stringify({ shape: sp.shape, blank: sp.blank, zone: sp.zone, colors: sp.colors, photos: sp.photos, pz: sp.pz, t: sp.t, price: sp.price }));
      var anyMock = FACES.some(function (f) { return s.faces[f] && s.faces[f].mock; });
      var MC = mobCrop(self, sp, both), tr = MC.tr, mob = MC.mob;
      var layers = FACES.map(function (side, i) {
        var f = s.faces[side], z = sp.pz[i]; if (!f || !z) return '';
        var S = SIZES[side], F = frameOf(z, side), zw = F.w, zh = F.h, zx = F.x, zy = F.y;
        var B = self.logoBox(side, zw / zh);
        var src = f.view || self.mockPng(side);
        return '<img class="ais-photo__logo" src="' + esc(src) + '" alt="" style="left:' + (zx + B.left / 100 * zw).toFixed(2) + '%;top:' + (zy + B.top / 100 * zh).toFixed(2) + '%;width:' + (B.width / 100 * zw).toFixed(2) + '%;height:' + (B.height / 100 * zh).toFixed(2) + '%">';
      }).join('');
      var extras = (badge && anyMock ? '<span class="ais-mock__badge">' + esc(bt.preview_sim || '') + '</span>' : '') +
        (!has ? '<span class="ais-mock__na">' + esc(fmt(bt.color_na || '{c}', { c: c.n })) + '</span>' : '') + MC.sw;
      return '<figure class="ais-mock ais-mock--photo' + (both ? ' ais-mock--both' : '') + '" data-mock="' + data + '"' + (badge ? ' data-badge' : '') + (both ? ' data-both' : '') + '>' +
        '<span class="ais-photo"><span class="ais-photo__in"' + tr + '><img class="ais-photo__base" src="' + esc(sized(photo, mob && tr ? 2000 : 900)) + '" alt="' + esc(String(sp.t || '').split(' (')[0]) + '" loading="lazy" width="900" height="900">' + layers + '</span></span>' + extras + '</figure>';
    };
    // Boutons Devant / Dos / Tout le t-shirt de l'aperçu mobile
    inst.thread.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v25-side], [data-v25-full]'); if (!b) return;
      var V = inst.v25 = inst.v25 || { side: null, full: false };
      if (b.hasAttribute('data-v25-side')) { V.side = b.getAttribute('data-v25-side'); V.full = false; } else V.full = !V.full;
      if (b.closest('[data-v11-stage]')) { inst.renderResult(); return; }
      var fig = b.closest('figure'), box = fig && fig.parentNode, sp = inst.curSupport && inst.curSupport();
      if (!fig || !sp) return;
      var tmp = document.createElement('div'); tmp.innerHTML = inst.mock(sp, inst.s.color, fig.hasAttribute('data-badge'), fig.hasAttribute('data-both'));
      if (tmp.firstChild) box.replaceChild(tmp.firstChild, fig);
    });
    // L'aperçu de l'éditeur suit le vêtement choisi (sinon le premier du sport) : refreshMock utilise supportsFor()[0]
    var baseRefresh = inst.refreshMock;
    inst.refreshMock = function () {
      var box = this.resultEl && this.resultEl.querySelector('[data-mockbox]');
      if (!box) return baseRefresh.apply(this, arguments);
      var base = this.s.support || this.supportsFor(this.s.niche)[0] || { shape: 'tee', blank: '' };
      box.innerHTML = this.mock(base, this.s.color, true, true);
    };
    var baseRender = inst.renderResult;
    inst.renderResult = function () {
      baseRender.apply(this, arguments);
      this.refreshMock();
      var body = this.resultEl && this.resultEl.querySelector('.ais-result__body');
      if (body && !body.querySelector('.ais-delay')) {
        var line = this.delayLine(this.fromPrice() ? fmt(t.from, { p: this.fromPrice() }) : '');
        var act = body.querySelector('.ais-actions');
        if (line && act) act.insertAdjacentHTML('beforebegin', line);
      }
    };

    /* ---------- Prix + délai dans le choix du vêtement et le récapitulatif ---------- */
    var self0 = inst;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          // Récapitulatif : avant le bouton « Personnaliser »
          var handoff = n.querySelector && n.querySelector('[data-act="handoff"]');
          if (handoff) {
            var body = handoff.closest('.ais-result__body');
            if (body && !body.querySelector('.ais-delay')) {
              body.querySelectorAll(':scope > .ais-note').forEach(function (p) { if (self0.s.support && p.textContent.trim() === self0.s.support.price) p.remove(); });
              var line = self0.delayLine(self0.s.support ? self0.s.support.price : '');
              if (line) handoff.closest('.ais-actions').insertAdjacentHTML('beforebegin', line);
            }
          }
          // Choix du vêtement : une seule ligne de délai sous la liste
          var sup = n.querySelector && n.querySelector('.ais-supports');
          if (sup && !n.querySelector('.ais-delay') && sup.querySelector('[data-act="pick-support"]')) {
            var dl = self0.delayLine('');
            if (dl) sup.insertAdjacentHTML('afterend', dl);
          }
        });
      });
    }).observe(inst.thread, { childList: true });

    /* ---------- Réponses en un clic + cartes d'orientation ---------- */
    inst.addChips = function (opts) {
      if (!opts || !opts.length) return;
      this.quick.insertAdjacentHTML('beforeend', opts.map(function (o) {
        return '<button type="button" class="ais-chip' + (o.ghost ? ' ais-chip--ghost' : '') + (o.sug ? ' ais-chip--sug' : '') + '" data-cmd="' + esc(o.cmd) + '"' + (o.v != null ? ' data-value="' + esc(o.v) + '"' : '') + '>' + esc(o.l) + '</button>';
      }).join(''));
    };
    inst.sugChips = function (list) {
      return (list || []).filter(Boolean).slice(0, 3).map(function (x) { return { cmd: 'say', v: x, l: x, sug: true }; });
    };
    inst.designIndex = function (cid) { var i = -1; this.designs.forEach(function (d, k) { if (i < 0 && d.cid === cid) i = k; }); return i; };
    inst.aiDesigns = function () {
      var s = this.s, out = [];
      this.designs.forEach(function (d, i) { if ((d.tags || []).map(function (x) { return String(x).toLowerCase(); }).indexOf('ia') > -1) out.push(i); });
      var mine = out.filter(function (i) { return !s.niche || inst.designs[i].niche === s.niche; });
      return (mine.length ? mine : out).slice(0, 3);
    };
    inst.routeCard = function (j) {
      var self = this, s = this.s, idx = (j.designs || []).map(function (c) { return self.designIndex(c); }).filter(function (i) { return i > -1; });
      var route = j.route;
      if (route === 'photo' && !idx.length) idx = this.aiDesigns();
      if (route === 'designs' && !idx.length) this.designs.forEach(function (d, i) { if (idx.length < 3 && d.official && d.niche === s.niche) idx.push(i); });
      if (!idx.length) return '';
      var photo = route === 'photo';
      return '<div class="ais-spirit ais-route"><p class="ais-spirit__title">' + esc(photo ? t.route_photo : t.route_designs) + '</p><ul class="ais-mini" role="list">' + idx.slice(0, 3).map(function (i) {
        var d = self.designs[i], inner = '<img src="' + esc(sized(d.img, 120)) + '" alt="" loading="lazy" width="44" height="44"><span>' + esc(d.t) + '</span>';
        return '<li>' + (photo
          ? '<a class="ais-mini__item" href="' + esc(d.url) + '">' + inner + IC.arrow + '</a>'
          : '<button type="button" class="ais-mini__item" data-act="pick-design" data-i="' + i + '">' + inner + '</button>') + '</li>';
      }).join('') + '</ul></div>';
    };
    inst.resultChips = function (sugs) {
      var s = this.s, tw = bt.tweaks || {};
      this.chips(this.sugChips(sugs).concat([
        { cmd: 'tweak', v: 'minimal', l: tw.minimal }, { cmd: 'tweak', v: 'funny', l: tw.funny }, { cmd: 'tweak', v: 'text', l: tw.text },
        { cmd: 'tweak', v: 'sides', l: tw.sides }
      ].filter(function (c) { return c.l && !(c.v === 'minimal' && s.style === 'minimal'); })).slice(0, 5));
    };

    /* ---------- Manu : un tour de chat (remplace askManu de ai-studio.js / v9) ---------- */
    inst.askManu = function (text, opts) {
      opts = opts || {};
      if (this._fresh) { this._fresh = false; if (!this.heroNiche && this.s && !opts.keepSport) this.s.sport = null; }
      var self = this, s = this.s, run = this.run;
      s.history.push({ role: 'user', content: text });
      if (!this.endpoint) { if (opts.stage === 'result') return this.retouch(text, null); if (opts.stage) return; return this.localManu(); }
      this.busy = true; this.typing(true);
      this.loadFacts().then(function (facts) {
        return fetch(self.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          action: 'chat', locale: self.loc, messages: s.history.slice(-10),
          known: { sport: s.sport, idea: s.idea, logo_text: s.logoText, style: s.style, sides: s.sides, questions: s.questions, stage: opts.stage || null, image: s.imageNote || null, remix: s.remix || null },
          facts: facts, image: opts.image || undefined
        }) });
      })
        .then(function (r) { if (!r.ok) { var e = new Error(r.status); e.status = r.status; throw e; } return r.json(); })
        .then(function (j) {
          if (run !== self.run) return;
          self.typing(false); self.busy = false;
          if (j.blocked) { self.refuse(); return; }
          if (j.sport && SPORTS.indexOf(j.sport) > -1) { s.sport = j.sport; s.niche = NICHE_OF[j.sport]; }
          if (j.idea && !opts.stage) s.idea = j.idea;
          if (j.logo_text && !s.noText) s.logoText = j.logo_text;
          if (j.style) s.style = j.style;
          if (j.goal) s.goal = j.goal;
          if (j.sides) s.sides = j.sides;
          if (j.front_desc) s.frontDesc = j.front_desc;
          if (j.back_desc) s.backDesc = j.back_desc;
          if (j.image_note) s.imageNote = j.image_note;
          if (j.reply) s.history.push({ role: 'assistant', content: j.reply });
          var card = self.routeCard(j);
          (j.reply ? self.bot(rich(j.reply)) : Promise.resolve())
            .then(function () { return card ? self.bot(card, true) : null; })
            .then(function () {
              if (run !== self.run) return;
              var sugs = self.sugChips(j.suggestions);
              // Image jointe : Manu la regarde, le visiteur choisit
              if (opts.image && opts.file && j.route !== 'photo') {
                s.pending = 'manu';
                var first = j.image_use === 'print' ? 'img-print' : 'img-inspire';
                var other = first === 'img-print' ? 'img-inspire' : 'img-print';
                self.chips([{ cmd: first, l: t[first.replace('-', '_')] }, { cmd: other, l: t[other.replace('-', '_')], ghost: true }]);
                return;
              }
              if (opts.stage === 'result') {
                if (j.ready) { self.retouch(text, j.place); return; }
                s.pending = 'result'; self.resultChips(j.suggestions); return;
              }
              if (opts.stage === 'checkout') {
                s.pending = null;
                self.chips(sugs.concat(s.support ? [{ cmd: 'change-support', l: bt.change_support, ghost: true }] : []).concat([{ cmd: 'change-design', l: bt.change_design, ghost: true }]).filter(function (c) { return c.l; }));
                return;
              }
              if (j.route === 'upload') sugs.unshift({ cmd: 'attach', l: t.route_upload });
              if (!j.ready && j.asking && j.asking !== 'image_use' && s.questions < 3) {
                s.questions++;
                self.askChips(j.asking, j.style_options);
                if (j.asking !== 'sides' && j.asking !== 'style') self.addChips(sugs);
                return;
              }
              if (!j.ready) { s.pending = 'manu'; self.chips(sugs); if (window.matchMedia('(min-width: 750px)').matches) self.replyField.focus({ preventScroll: true }); return; }
              self.generateFaces(self.facesToDraw());
            });
        })
        .catch(function () {
          if (run !== self.run) return;
          self.typing(false); self.busy = false;
          if (opts.stage || opts.image) {
            self.bot(esc(t.chat_error)).then(function () { if (opts.stage === 'result') { s.pending = 'result'; self.resultChips([]); } else s.pending = s.pending || 'manu'; });
            return;
          }
          self.localManu();
        });
    };
    // Retouche validée par Manu : la face citée seulement, sinon les faces prévues
    inst.retouch = function (text, place) {
      var s = this.s;
      s.idea = (s.idea || '') + ' ' + (bt.retouch_prefix || '') + ' ' + text;
      var only = place === 'front' || place === 'back' ? [place] : null;
      if (!this.endpoint && only) { if (only[0] === 'back') s.backDesc = ((s.backDesc || '') + ' ' + text).trim(); else s.frontDesc = ((s.frontDesc || '') + ' ' + text).trim(); }
      this.lockThread(); this.resultEl = null;
      this.generateFaces(only || this.facesToDraw(), !!only);
    };

    /* ---------- Logo : l'image d'inspiration part avec la première face dessinée ---------- */
    inst.apiLogo = function (side, ref) {
      var s = this.s;
      var brief = { sport: s.sport, idea: s.idea, logo_text: s.noText ? null : s.logoText, style: s.style, goal: s.goal, place: side, front_desc: s.frontDesc, back_desc: s.backDesc, locale: this.loc, inspiration: s.imageNote || null, front_format: this.frontFormat(), zone: this.zoneFor ? this.zoneFor(side) : undefined };
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      if (ctrl) setTimeout(function () { ctrl.abort(); }, 110000);
      var body = { action: 'logo', side: side, brief: brief, ref: ref || undefined, inspire: !ref && s.inspire ? s.inspire : undefined };
      return fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) { var e = new Error(r.status); e.status = r.status; throw e; } return r.json(); })
        .then(function (j) { if (!j || !j.image_url) throw new Error('empty'); return j.image_url; });
    };

    /* ---------- Messages libres : passent par Manu selon l'étape ---------- */
    var baseFree = inst.freeText;
    inst.freeText = function (text) {
      var s = this.s;
      if (BLOCKED.test(String(text).toLowerCase())) return baseFree.apply(this, arguments);
      if (s.pending === 'result' && s.idea) { this.user(text); this.quick.innerHTML = ''; this.askManu(text, { stage: 'result' }); return; }
      if (s.pending === 'designs') { this.user(text); this.quick.innerHTML = ''; s.path = 'story'; s.design = null; s.idea = text; this.updateTokens(); this.askManu(text); return; }
      if (!s.pending && (s.designOk || s.design || s.support)) { this.user(text); this.quick.innerHTML = ''; this.askManu(text, { stage: 'checkout' }); return; }
      return baseFree.apply(this, arguments);
    };
    var baseCommand = inst.command;
    inst.command = function (cmd, value, label) {
      var s = this.s;
      if (cmd === 'say') { this.quick.innerHTML = ''; return this.freeText(value || label); }
      if (cmd === 'attach') { if (this.attachInput) this.attachInput.click(); return; }
      if (cmd === 'w-designs') { this.user(label); this.quick.innerHTML = ''; s.path = 'design'; s.niche = s.niche || NICHE_OF[this.heroNiche || 'crossfit']; return this.showDesigns(); }
      if (cmd === 'w-photo') {
        this.user(label); this.quick.innerHTML = '';
        var card = this.routeCard({ route: 'photo', designs: [] });
        if (!card) { s.pending = 'idea'; return; }
        return this.bot(card, true).then(function () { s.pending = 'idea'; });
      }
      if (cmd === 'img-print' || cmd === 'img-inspire') {
        var att = this.attached; if (!att) return;
        this.user(label); this.quick.innerHTML = ''; this.lockThread();
        if (cmd === 'img-print') {
          this.attached = null;
          var side = s.pending === 'result' || this.resultEl ? s.edit : (att.h / att.w > 0.6 ? 'back' : 'front');
          this._quietUser = true;
          return this.ownFile(att.file, side, false);
        }
        s.inspire = att.big; s.path = 'story'; this.attached = null;
        if (!s.idea) s.idea = att.text || t.img_idea;
        this.updateTokens();
        return this.askManu(label);
      }
      return baseCommand.apply(this, arguments);
    };
    // ownFile() écrit le nom du fichier en bulle : inutile quand l'image est déjà affichée dans le fil
    var baseUser = inst.user;
    inst.user = function () { if (this._quietUser) { this._quietUser = false; return; } return baseUser.apply(this, arguments); };

    /* ---------- Trombone : image du visiteur dans le chat ---------- */
    var reply = root.querySelector('[data-ais-reply]');
    if (reply && !reply.querySelector('[data-v11-attach]')) {
      reply.classList.add('ais-reply--attach');
      reply.insertAdjacentHTML('afterbegin', '<label class="ais-reply__attach" title="' + esc(t.attach) + '">' + IC.clip + '<span class="ais-vh">' + esc(t.attach) + '</span><input type="file" class="ais-vh" accept="image/png,image/jpeg,image/webp,image/svg+xml,.svg" data-v11-attach></label>');
      inst.attachInput = reply.querySelector('[data-v11-attach]');
      inst.attachInput.addEventListener('change', function () {
        var f = inst.attachInput.files && inst.attachInput.files[0]; inst.attachInput.value = '';
        if (f) inst.attach(f);
      });
    }
    inst.attach = function (file) {
      var self = this, s = this.s, text = this.replyField.value.trim();
      if (this.busy) return;
      if (!/^image\/(png|jpe?g|webp|svg\+xml)$/i.test(file.type) && !/\.svg$/i.test(file.name)) { this.bot(esc(t.img_bad)); return; }
      if (file.size > 15 * 1024 * 1024) { this.bot(esc(t.img_bad)); return; }
      this.replyField.value = ''; this.quick.innerHTML = '';
      var isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
      // Sans IA ou SVG (logo vectoriel) : on l'imprime tel quel directement
      if (!this.endpoint || isSvg) { var side = this.resultEl ? s.edit : 'front'; return this.ownFile(file, side, false); }
      this.busy = true;
      readUrl(file).then(function (url) { return Promise.all([shrink(url, 768), shrink(url, 1024)]); }).then(function (r) {
        self.busy = false;
        self.attached = { file: file, small: r[0].url, big: r[1].url, w: r[1].w, h: r[1].h, text: text };
        self.user(text || t.img_msg);
        var msgs = self.thread.querySelectorAll('.ais-msg--user'), last = msgs[msgs.length - 1];
        if (last) last.insertAdjacentHTML('beforeend', '<img class="ais-msg__img" src="' + esc(r[0].url) + '" alt="">');
        self.scroll();
        if (!s.path) s.path = 'story';
        self.askManu((text ? text + ' ' : '') + '[image]', { image: r[0].url, file: file });
      }, function () { self.busy = false; self.bot(esc(t.img_bad)); });
    };

    /* ---------- v11 · Éditeur directement sur le mockup (retours du 19/10) ----------
     * Photo Shopify de la variante à gauche, logos posés dans leurs zones : glisser pour placer, coin pour la taille,
     * barre par face (Refaire / Créer avec Manu · Importer · Retirer). À droite : vêtement, couleur, prix + délai, « Je garde ».
     * Plus de designs signature sous le résultat. Sans photo pour le vêtement : éditeur de ai-studio.js. */
    inst.sameSpirit = function () { return ''; };
    var plainRender = inst.renderResult;
    inst.curSupport = function () {
      var list = this.supportsFor(this.s.niche), sp = this.s.support;
      if (sp && list.indexOf(sp) > -1) return sp;
      return list.filter(function (x) { return x.pz; })[0] || list[0] || null;
    };
    // Position du logo en % de la zone affichée. zr = largeur / hauteur de cette zone (défaut : zone générique 28 × 12 / 28 × 32).
    // Même centre (fraction de la zone) et même largeur relative que sur le mockup, proportions du logo gardées, logo contenu dans la zone.
    inst.logoBox = function (side, zr) {
      var f = this.s.faces[side], S = SIZES[side], R = placeRect(f, side, this.s.pos[side]);
      zr = zr > 0 ? zr : S[0] / S[1];
      var a = R.w / R.h, wp = R.w / S[0] * 100, hp = a ? wp * zr / a : 0;
      if (hp > 100) { hp = 100; wp = hp * a / zr; }
      var cx = (R.x + R.w / 2) / S[0] * 100, cy = (R.y + R.h / 2) / S[1] * 100;
      return { left: clamp(cx - wp / 2, 0, 100 - wp), top: clamp(cy - hp / 2, 0, 100 - hp), width: wp, height: hp };
    };
    inst.stageHtml = function (sp) {
      var self = this, s = this.s, photo = this.photoOf(sp, s.color), canAi = s.path === 'story' && !!s.idea && !!this.endpoint;
      var MC = mobCrop(self, sp, true);
      var zones = FACES.map(function (side, i) {
        var z = sp.pz[i]; if (!z) return '';
        var S = SIZES[side], F = frameOf(z, side), zw = F.w, zh = F.h, f = s.faces[side], sel = s.edit === side;
        var name = (bt.sides && bt.sides[side]) || side;
        var inner = '';
        if (f) {
          var b = self.logoBox(side, zw / zh);
          inner = '<img class="ais-zone__logo" data-v11-drag="' + side + '" tabindex="0" role="img" aria-label="' + esc(fmt(t.e_select, { side: name.toLowerCase() })) + '" src="' + esc(f.view || self.mockPng(side)) + '" alt="" draggable="false" style="left:' + b.left.toFixed(2) + '%;top:' + b.top.toFixed(2) + '%;width:' + b.width.toFixed(2) + '%;height:' + b.height.toFixed(2) + '%">' +
            '<span class="ais-zone__handle" data-v11-size="' + side + '" aria-hidden="true" style="left:' + (b.left + b.width).toFixed(2) + '%;top:' + (b.top + b.height).toFixed(2) + '%"></span>';
        } else {
          inner = '<span class="ais-zone__empty" aria-hidden="true">+</span>';
        }
        var bar = '<span class="ais-zone__bar" role="group" aria-label="' + esc(name) + '"><b>' + esc(name) + '</b>' +
          (canAi ? '<button type="button" class="ais-zone__btn" data-act="face-redo" data-v11-face="' + side + '" title="' + esc(f ? t.e_redo : t.e_create) + '">' + (f ? IC.redo : IC.spark) + '<span' + (f ? ' class="ais-vh"' : '') + '>' + esc(f ? t.e_redo : t.e_create) + '</span></button>' : '') +
          '<label class="ais-zone__btn" data-v11-face="' + side + '" title="' + esc(t.e_upload) + '">' + IC.up + '<span class="ais-vh">' + esc(t.e_upload) + '</span><input type="file" class="ais-vh" accept="image/png,image/jpeg,image/webp,image/svg+xml,.svg" data-face-file></label>' +
          (f ? '<button type="button" class="ais-zone__btn" data-act="face-clear" data-v11-face="' + side + '" title="' + esc(t.e_remove) + '">' + IC.x + '<span class="ais-vh">' + esc(t.e_remove) + '</span></button>' : '') + '</span>';
        return '<div class="ais-zone' + (sel ? ' is-sel' : '') + (f ? '' : ' is-empty') + (F.y < 18 ? ' ais-zone--low' : '') + '" data-v11-zone="' + side + '" style="left:' + F.x.toFixed(2) + '%;top:' + F.y.toFixed(2) + '%;width:' + zw.toFixed(2) + '%;height:' + zh.toFixed(2) + '%">' + inner + bar + '</div>';
      }).join('');
      var anyMock = FACES.some(function (f) { return s.faces[f] && s.faces[f].mock; });
      return '<div class="ais-stage" data-v11-stage><span class="ais-stage__in"' + MC.tr + '><img class="ais-stage__base" src="' + esc(sized(photo, MC.mob && MC.tr ? 2000 : 1000)) + '" alt="' + esc(String(sp.t || '').split(' (')[0]) + '" width="1000" height="1000">' + zones + '</span>' +
        (anyMock ? '<span class="ais-mock__badge">' + esc(bt.preview_sim || '') + '</span>' : '') + MC.sw + '</div>';
    };
    inst.prodsHtml = function (cur) {
      var self = this, s = this.s;
      return '<div class="ais-prods" role="group" aria-label="' + esc(t.e_product) + '">' + this.supports.map(function (sp, i) {
        if (!(sp.niche === s.niche || sp.niche === 'all')) return '';
        var ph = self.photoOf(sp, s.color);
        return '<button type="button" class="ais-prod" data-v11-sup="' + i + '" aria-pressed="' + (sp === cur) + '">' +
          (ph ? '<img src="' + esc(sized(ph, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<span class="ais-prod__n">' + esc(String(sp.t || '').split(' (')[0].replace(/\s+À PERSONNALISER$/i, '')) + '</span><span class="ais-prod__p">' + esc(sp.price) + '</span></button>';
      }).join('') + '</div>';
    };
    inst.renderResult = function () {
      var el = this.resultEl; if (!el) return;
      var s = this.s, sp = this.curSupport();
      if (!sp || !sp.pz || !this.photoOf(sp, s.color)) { plainRender.apply(this, arguments); return; }
      s.support = sp;
      if (!s.faces[s.edit]) s.edit = s.faces.front ? 'front' : (s.faces.back ? 'back' : s.edit);
      el.classList.add('ais-result--studio');
      el.innerHTML = this.stageHtml(sp) +
        '<div class="ais-result__body ais-side">' +
          '<p class="ais-side__k">' + esc(t.e_product) + '</p>' + this.prodsHtml(sp) +
          this.swatches() +
          '<p class="ais-note" data-quality></p>' +
          this.delayLine(sp.price) +
          '<div class="ais-actions"><button type="button" class="ais-btn ais-btn--primary" data-act="keep">' + esc(bt.keep || 'OK') + IC.arrow + '</button></div>' +
          '<p class="ais-note">' + esc(t.e_hint) + '</p>' +
        '</div>';
      this.refreshQuality();
    };
    inst.refreshMock = function () { if (this.resultEl && this.resultEl.querySelector('[data-v11-stage]')) return this.renderResult(); return baseRefresh.apply(this, arguments); };
    // La couleur change la photo du vêtement : on redessine l'éditeur
    var baseSetColor = inst.setColor;
    inst.setColor = function () { baseSetColor.apply(this, arguments); if (this.resultEl && this.resultEl.querySelector('[data-v11-stage]')) this.renderResult(); };
    // Le vêtement est déjà choisi dans l'éditeur : « Je garde » mène directement au récapitulatif
    var baseLock = inst.lockThread;
    inst.lockThread = function () {
      baseLock.apply(this, arguments);
      this.thread.querySelectorAll('[data-v11-sup], [data-v11-face], .ais-zone__btn').forEach(function (b) { b.disabled = true; b.removeAttribute('data-v11-sup'); b.removeAttribute('data-v11-face'); });
      this.thread.querySelectorAll('[data-v11-drag], [data-v11-size]').forEach(function (el) { el.removeAttribute('data-v11-drag'); el.removeAttribute('data-v11-size'); el.removeAttribute('tabindex'); });
      this.thread.querySelectorAll('.ais-stage').forEach(function (st) { st.classList.add('is-locked'); });
    };
    var liveStage = function (el) { return inst.resultEl && inst.resultEl.contains(el); };
    // Avant les écouteurs de ai-studio.js (phase de capture) : la face visée devient la face éditée
    inst.thread.addEventListener('click', function (e) {
      var fb = e.target.closest('[data-v11-face]');
      if (fb && liveStage(fb)) { inst.s.edit = fb.getAttribute('data-v11-face'); return; }
      var pb = e.target.closest('[data-v11-sup]');
      if (pb && liveStage(pb) && !inst.busy) {
        e.preventDefault();
        inst.s.support = inst.supports[+pb.getAttribute('data-v11-sup')];
        // couleur absente sur ce vêtement : on garde la photo la plus proche (noir / blanc)
        inst.renderResult();
      }
    }, true);
    var select = function (side) {
      inst.s.edit = side;
      inst.resultEl.querySelectorAll('[data-v11-zone]').forEach(function (z) { z.classList.toggle('is-sel', z.getAttribute('data-v11-zone') === side); });
      inst.refreshQuality();
    };
    var place = function (side) {
      var z = inst.resultEl && inst.resultEl.querySelector('[data-v11-zone="' + side + '"]'); if (!z) return;
      var b = inst.logoBox(side, z.offsetWidth / (z.offsetHeight || 1)), img = z.querySelector('[data-v11-drag]'), h = z.querySelector('[data-v11-size]');
      if (img) { img.style.left = b.left.toFixed(2) + '%'; img.style.top = b.top.toFixed(2) + '%'; img.style.width = b.width.toFixed(2) + '%'; img.style.height = b.height.toFixed(2) + '%'; }
      if (h) { h.style.left = (b.left + b.width).toFixed(2) + '%'; h.style.top = (b.top + b.height).toFixed(2) + '%'; }
    };
    inst.thread.addEventListener('pointerdown', function (e) {
      var lg = e.target.closest('[data-v11-drag]'), hd = e.target.closest('[data-v11-size]'), el = hd || lg;
      if (!el || !liveStage(el) || inst.busy) return;
      var side = el.getAttribute(hd ? 'data-v11-size' : 'data-v11-drag'), s = inst.s, f = s.faces[side]; if (!f) return;
      select(side);
      e.preventDefault();
      var zone = el.closest('[data-v11-zone]'), Z = zone.getBoundingClientRect(), S = SIZES[side], p = s.pos[side];
      var start = { x: e.clientX, y: e.clientY, px: p.x, py: p.y }, fit = placeRect(f, side, { x: 0.5, y: 0.5, k: 1 }), R1 = placeRect(f, side, p);
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      zone.classList.add('is-moving');
      var move = function (ev) {
        if (hd) {
          var dw = Math.max((ev.clientX - start.x) / Z.width * S[0], (ev.clientY - start.y) / Z.height * S[1] * (R1.w / R1.h));
          p.k = clamp((R1.w + dw) / fit.w, 0.2, 1);
        } else {
          p.x = start.px + (ev.clientX - start.x) / Z.width; p.y = start.py + (ev.clientY - start.y) / Z.height;
        }
        var Q = placeRect(f, side, p); p.x = (Q.x + Q.w / 2) / S[0]; p.y = (Q.y + Q.h / 2) / S[1];
        place(side);
      };
      var up = function () {
        el.removeEventListener('pointermove', move); el.removeEventListener('pointerup', up); el.removeEventListener('pointercancel', up);
        zone.classList.remove('is-moving'); inst.refreshQuality();
      };
      el.addEventListener('pointermove', move); el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    });
    inst.thread.addEventListener('focusin', function (e) { var lg = e.target.closest('[data-v11-drag]'); if (lg && liveStage(lg)) select(lg.getAttribute('data-v11-drag')); });
    inst.thread.addEventListener('keydown', function (e) {
      var lg = e.target.closest('[data-v11-drag]'); if (!lg || !liveStage(lg)) return;
      var side = lg.getAttribute('data-v11-drag'), s = inst.s, p = s.pos[side], S = SIZES[side];
      var d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (d) { p.x += d[0] * 0.02; p.y += d[1] * 0.02; }
      else if (e.key === '+' || e.key === '=') p.k = clamp(p.k + 0.05, 0.2, 1);
      else if (e.key === '-' || e.key === '−') p.k = clamp(p.k - 0.05, 0.2, 1);
      else return;
      e.preventDefault();
      var Q = placeRect(s.faces[side], side, p); p.x = (Q.x + Q.w / 2) / S[0]; p.y = (Q.y + Q.h / 2) / S[1];
      place(side); inst.refreshQuality();
    });

    /* ---------- Créations offertes : en bas, au-dessus des réponses (plus visible que dans l'en-tête) ---------- */
    var dock = root.querySelector('.ais-dock');
    if (dock && inst.tokensEl && inst.tokensEl.parentNode !== dock) { inst.tokensEl.classList.add('ais-tokens--dock'); dock.insertBefore(inst.tokensEl, dock.firstChild); }

    /* ---------- « Recommencer » : nouvelle création dans le panneau (au lieu de fermer et revenir à l'accueil) ---------- */
    var rs = root.querySelector('[data-ais-restart]');
    if (rs) {
      var rs2 = rs.cloneNode(true);
      rs2.title = t.restart_t; rs2.setAttribute('aria-label', t.restart_t);
      rs.parentNode.replaceChild(rs2, rs);
      rs2.addEventListener('click', function () {
        if (inst.dialog.open) { inst.returnFocusKeep = inst.returnFocus; inst.dialog.close(); }
        inst.welcome();
      });
    }

    /* ---------- Ouverture depuis un lien : accueil vide (menu) ou remix d'une personnalisation ---------- */
    inst.welcome = function () {
      var self = this;
      this.open({ path: 'story', own: true });
      var s = this.s;
      s.pending = 'idea';
      this.bot(esc(t.welcome)).then(function () {
        var opts = [{ cmd: 'say', v: t.no_idea_msg, l: t.w_noidea }, { cmd: 'attach', l: t.w_logo }, { cmd: 'w-designs', l: t.w_designs, ghost: true }];
        if (self.aiDesigns().length) opts.push({ cmd: 'w-photo', l: t.w_photo, ghost: true });
        self.chips(opts);
        if (window.matchMedia('(min-width: 750px)').matches) self.replyField.focus({ preventScroll: true });
      });
    };
    inst.remix = function (seed) {
      var self = this;
      this.open({ path: 'story', own: true });
      var s = this.s;
      if (seed.niche === 'running') { s.sport = 'running'; s.niche = 'running'; } else { s.sport = this.heroNiche || null; s.niche = 'cf'; }
      this._fresh = false;
      var msg = (seed.design && seed.title ? fmt(t.remix_msg, { t: seed.title }) : t.remix_mine) + (seed.texts && seed.texts.length ? ' ' + fmt(t.remix_texts, { x: seed.texts.join(', ') }) : '');
      this.user(msg);
      if (!seed.img) { s.pending = 'idea'; this.bot(esc(t.remix_lost)); return; }
      var msgs = this.thread.querySelectorAll('.ais-msg--user'), last = msgs[msgs.length - 1];
      if (last) last.insertAdjacentHTML('beforeend', '<img class="ais-msg__img" src="' + esc(seed.img) + '" alt="">');
      s.idea = msg; s.remix = seed.design ? seed.title : null; s.inspire = seed.img;
      this.updateTokens();
      shrink(seed.img, 768).then(function (r) { self.askManu(msg, { image: r.url, keepSport: true }); }, function () { self.askManu(msg, { keepSport: true }); });
    };
    var m = /[?&]manu=([a-z0-9]+)/i.exec(location.search) || (/#manu\b/.test(location.hash) ? [0, '1'] : null);
    if (m) {
      setTimeout(function () {
        if (inst.dialog.open) return;
        var seed = m[1] === 'remix' ? store('rxManuSeed') : null;
        if (seed && Date.now() - (seed.at || 0) < 30 * 60 * 1000) { store('rxManuSeed', null); inst.remix(seed); }
        else inst.welcome();
        try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])manu=[a-z0-9]+&?/i, '$1').replace(/[?&]$/, '') + location.hash.replace(/#manu\b/, '')); } catch (e) {}
      }, 350);
    }
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
